// CSS Modules - component class name prefix: IconsList__
<template>
  <div>
    <div
      v-for="(list, index) in config.lists"
      :key="index"
      :class="[$style.container, 'columns', 'is-multiline']"
    >
      <div
        :class="[$style.blockContent, 'column', 'is-full']"
        v-if="config.title || config.text"
      >
        <h2 v-if="config.title">{{ config.title }}</h2>
        <div v-if="config.text" v-html="config.text"></div>
      </div>
      <dl
        v-for="(listItem, index) in list.listItems"
        :key="index"
        :class="[
          $style.listItem,
          'column',
          'is-half-tablet',
          { 'is-half-desktop': list.listItems.length === 2 },
          { 'is-one-quarter-desktop': list.listItems.length >= 3 }
        ]"
      >
        <dt :class="[$style.listItemTitle]">
          <h3 v-if="listItem.title">{{ listItem.title }}</h3>
        </dt>
        <dd  :class="[$style.listItemContent]">
          <ul>
            <li
              v-for="(listContent, index) in listItem.content"
              :key="index"
              :class="[$style.listItemContentItem]"
            >
              <img
                :class="[$style.listItemImageIcon]"
                v-if="listContent.image"
                :src="listContent.image"
                :alt="config.title"
              />
              <i
                v-else-if="listContent.icon.length > 0"
                :class="listContent.icon"
              ></i>
              <span v-if="listContent.text.length > 0">{{
                listContent.text
              }}</span>
            </li>
          </ul>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconsList",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style module lang="scss">
@import "./IconsList.scss";
</style>
